 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		123: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		123: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"b12a1e59bd81d339d65d","1":"ee75f6bb497f9d28a4f7","2":"fb7554adbb0f0db27167","3":"668e54b206169804c31f","4":"006f03e88b2644639c10","5":"5ff9c8c684fba0094632","6":"6f779d430c0999b0f428","7":"5a7eca34e407638cab05","8":"e6fe9400c2763c2d85e0","9":"cbb5741b9cbccd533a03","10":"b661c69447d0b7f7a410","11":"ba3545454dddd06de113","12":"56a968761d729f069fb4","13":"6a87c2b6918fdc4e6c67","14":"d6b775cb0bcba21efcf0","15":"70625702396cd4165566","16":"86f3f15d0d79340a0175","17":"823c23c2607cde049937","18":"be4f9b05ff2632dfdd08","19":"949b170cfd39a9083c54","20":"fef79c9222f64afdbe60","21":"412e2d76f5bdfbee3c14","22":"eee5ae0ee29f604e8e54","23":"a3bdc125580e4b5c7ff8","24":"458e70ab05e52011a57e","25":"3a0d8dac4f15d06686b1","26":"6bd54db243268faf9e9e","27":"d322432102a332f68241","28":"de08a046a68f348fe93a","29":"7b5f64926e187d8099f3","30":"3acf78e264ed85441728","31":"752e51eff55c65d693b9","32":"afbfb23921fa1a180c6b","33":"90c210d7335ee5c5cfd9","34":"c00b03273d98ee467569","35":"9c8cd3100962c432cbe1","36":"53cd5663f30f424a1255","37":"f0306344bf4d40ef804f","38":"f1312eb9bb2f1ff4cb03","39":"fc6497589376f624d6fc","40":"75f0dbf474fe84f6e4ac","41":"5d258ae0fb0ffa3b4a99","42":"25771938e5492454583e","43":"25dd2fd4279d3d49fafb","44":"0b1bf737f2807b0b611b","45":"fd210f3849f1d90a7a4e","46":"d3b6991cc2189b9e1fa0","47":"db90fffb3767ce5b8a7d","48":"877d9a2032fccfcdf8ec","49":"a74ef42bac704d5ffba4","50":"eaba784e4061f108f1da","51":"5ed5fd06c3129d8c14d7","52":"6483684e263b616f1558","53":"27d6e05caff58f22ee91","54":"00b1b29511d6ad65584f","55":"4bceaa0df80e6a6081c0","56":"727305e7af95faa54890","57":"2473771509ee1e281e11","58":"c49f28a8849b2b276915","59":"9b6c91d8b4807fc23f36","60":"928ea2efbbe867f705ac","61":"e394321b05a0c3e45528","62":"a35dc4a3bdbfab7e7918","63":"c102542f79619a045147","64":"fd1b8ffa4c152a186120","65":"9d88ec570287cce1c113","66":"164a603016002dd4a1c4","67":"1b45928e7684d95c7906","68":"1758b03f6ab3b852f531","69":"c9873444977506767255","70":"c3a042ad7ebb71a9e605","71":"3d921fb89b1f6992ec6a","72":"071df050b87bfc29e3f6","73":"28da74ed8d602122e670","74":"27c75bb2608c450746bd","75":"b27bdaa73d720f5e264f","76":"e0e0245b1f4a4566c9ae","77":"7a8f9c59b0e96101ecf3","78":"8e060a26eb98f713b09d","79":"6586adb021b0cf1dae48","80":"a9881b4142bde9bc2bbc","81":"5342802a9aecca33ec0f","82":"a26f910d5124c7eaa14f","83":"e310352ac97f72cc7455","84":"94c30c24fe8e2ded8673","85":"a044ca8de18222d91c4f","86":"e1520bb326e6db80b959","87":"84b1d2354a8d3031bc75","88":"a2cf16feb2c40b0cd9b5","89":"0fdd3aadc10040e28155","90":"2b5b7dd47a2ea233b82d","91":"e7b66d30ddc2375645c7","92":"eed30d718d7f567f10ad","93":"cd174abed79e5e4f71bb","94":"630be4d032042b350d72","95":"26b7a7002860d5895f2e","96":"e5ef43bb5af35b59acc1","97":"00fe0c44c7b16c047dd9","98":"c3371df00764c079578e","99":"46e278aec4083afa4e65","100":"221899c4f1bfa97042ef","101":"d789436f74df3633b23b","102":"998fc7d958488773d7cd","103":"3cd20385ec79eab95425","104":"1cc3f720c2840469181f","105":"9c9ac90b97340b32fda1","106":"54f9c37cdc584748020a","107":"f8a2a30a17da3a2b46c7","108":"b4607a4156665799e2a5","109":"bdba20b0208bb315dc6c","110":"267c5447b427f6b96776","111":"62d615a99c0c6cb75ba2","112":"c153407784720942f527","113":"041bf875e4583242736c","114":"710596ba66c8936c36dc","115":"8eb7a0854a622041b7d0","116":"8be9d40c1272d4058e42","117":"e439de424bf4aaeee64c","118":"72fffc3bbb4205c3cf88","119":"c92205b1b7cbe663b82b","120":"cb1935494161e8fd7515","121":"1fe94dc6a3137585c68c","122":"995ac779c443358a5d1b","124":"988a7a6730ef915cbeb3","125":"964edaa102dc11841f0a","126":"8d0d2f73a55a1297aaab","127":"1221c093a5413ea0106c","128":"75adb05b8f0216e430e0","129":"7f42d48327fb14f71cfd","130":"d5c68b86fa112c2ed93b","131":"39701e13214f6b98487c","132":"8a15fa0c474b6f9d7480","133":"440b434b46f52e43161e","134":"a565bcc13e6295b3ffce","135":"99567f8b7a792cbfeb56","136":"c8342f0a25283ff1f278","137":"906aa7481725b20363e1","138":"53c75f70235aec35fa33","139":"af0d63e6358881464e11"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"33":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"29":"menuDe","30":"menuEn","31":"menuEs","32":"menuFr","33":"styles","124":"staticTextDe","125":"staticTextES","126":"staticTextEn","127":"staticTextEs","128":"staticTextFr","129":"videojsplugins"}[chunkId]||chunkId) + "." + {"0":"b12a1e59bd81d339d65d","1":"ee75f6bb497f9d28a4f7","2":"fb7554adbb0f0db27167","3":"668e54b206169804c31f","4":"006f03e88b2644639c10","5":"5ff9c8c684fba0094632","6":"6f779d430c0999b0f428","7":"5a7eca34e407638cab05","8":"e6fe9400c2763c2d85e0","9":"cbb5741b9cbccd533a03","10":"b661c69447d0b7f7a410","11":"ba3545454dddd06de113","12":"56a968761d729f069fb4","13":"6a87c2b6918fdc4e6c67","14":"d6b775cb0bcba21efcf0","15":"70625702396cd4165566","16":"86f3f15d0d79340a0175","17":"823c23c2607cde049937","18":"be4f9b05ff2632dfdd08","19":"949b170cfd39a9083c54","20":"fef79c9222f64afdbe60","21":"412e2d76f5bdfbee3c14","22":"eee5ae0ee29f604e8e54","23":"a3bdc125580e4b5c7ff8","24":"458e70ab05e52011a57e","25":"3a0d8dac4f15d06686b1","26":"6bd54db243268faf9e9e","27":"d322432102a332f68241","28":"de08a046a68f348fe93a","29":"7b5f64926e187d8099f3","30":"3acf78e264ed85441728","31":"752e51eff55c65d693b9","32":"afbfb23921fa1a180c6b","33":"90c210d7335ee5c5cfd9","34":"c00b03273d98ee467569","35":"9c8cd3100962c432cbe1","36":"53cd5663f30f424a1255","37":"f0306344bf4d40ef804f","38":"f1312eb9bb2f1ff4cb03","39":"fc6497589376f624d6fc","40":"75f0dbf474fe84f6e4ac","41":"5d258ae0fb0ffa3b4a99","42":"25771938e5492454583e","43":"25dd2fd4279d3d49fafb","44":"0b1bf737f2807b0b611b","45":"fd210f3849f1d90a7a4e","46":"d3b6991cc2189b9e1fa0","47":"db90fffb3767ce5b8a7d","48":"877d9a2032fccfcdf8ec","49":"a74ef42bac704d5ffba4","50":"eaba784e4061f108f1da","51":"5ed5fd06c3129d8c14d7","52":"6483684e263b616f1558","53":"27d6e05caff58f22ee91","54":"00b1b29511d6ad65584f","55":"4bceaa0df80e6a6081c0","56":"727305e7af95faa54890","57":"2473771509ee1e281e11","58":"c49f28a8849b2b276915","59":"9b6c91d8b4807fc23f36","60":"928ea2efbbe867f705ac","61":"e394321b05a0c3e45528","62":"a35dc4a3bdbfab7e7918","63":"c102542f79619a045147","64":"fd1b8ffa4c152a186120","65":"9d88ec570287cce1c113","66":"164a603016002dd4a1c4","67":"1b45928e7684d95c7906","68":"1758b03f6ab3b852f531","69":"c9873444977506767255","70":"c3a042ad7ebb71a9e605","71":"3d921fb89b1f6992ec6a","72":"071df050b87bfc29e3f6","73":"28da74ed8d602122e670","74":"27c75bb2608c450746bd","75":"b27bdaa73d720f5e264f","76":"e0e0245b1f4a4566c9ae","77":"7a8f9c59b0e96101ecf3","78":"8e060a26eb98f713b09d","79":"6586adb021b0cf1dae48","80":"a9881b4142bde9bc2bbc","81":"5342802a9aecca33ec0f","82":"a26f910d5124c7eaa14f","83":"e310352ac97f72cc7455","84":"94c30c24fe8e2ded8673","85":"a044ca8de18222d91c4f","86":"e1520bb326e6db80b959","87":"84b1d2354a8d3031bc75","88":"a2cf16feb2c40b0cd9b5","89":"0fdd3aadc10040e28155","90":"2b5b7dd47a2ea233b82d","91":"e7b66d30ddc2375645c7","92":"eed30d718d7f567f10ad","93":"cd174abed79e5e4f71bb","94":"630be4d032042b350d72","95":"26b7a7002860d5895f2e","96":"e5ef43bb5af35b59acc1","97":"00fe0c44c7b16c047dd9","98":"c3371df00764c079578e","99":"46e278aec4083afa4e65","100":"221899c4f1bfa97042ef","101":"d789436f74df3633b23b","102":"998fc7d958488773d7cd","103":"3cd20385ec79eab95425","104":"1cc3f720c2840469181f","105":"9c9ac90b97340b32fda1","106":"54f9c37cdc584748020a","107":"f8a2a30a17da3a2b46c7","108":"b4607a4156665799e2a5","109":"bdba20b0208bb315dc6c","110":"267c5447b427f6b96776","111":"62d615a99c0c6cb75ba2","112":"c153407784720942f527","113":"041bf875e4583242736c","114":"710596ba66c8936c36dc","115":"8eb7a0854a622041b7d0","116":"8be9d40c1272d4058e42","117":"e439de424bf4aaeee64c","118":"72fffc3bbb4205c3cf88","119":"c92205b1b7cbe663b82b","120":"cb1935494161e8fd7515","121":"1fe94dc6a3137585c68c","122":"995ac779c443358a5d1b","124":"988a7a6730ef915cbeb3","125":"964edaa102dc11841f0a","126":"8d0d2f73a55a1297aaab","127":"1221c093a5413ea0106c","128":"75adb05b8f0216e430e0","129":"7f42d48327fb14f71cfd","130":"d5c68b86fa112c2ed93b","131":"39701e13214f6b98487c","132":"8a15fa0c474b6f9d7480","133":"440b434b46f52e43161e","134":"a565bcc13e6295b3ffce","135":"99567f8b7a792cbfeb56","136":"c8342f0a25283ff1f278","137":"906aa7481725b20363e1","138":"53c75f70235aec35fa33","139":"af0d63e6358881464e11"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				(function insert(linkTag) {
 				      if (document.querySelector('#assets-main-stylesheet')) {
 				        return;
 				      }
 				      document.head.appendChild(linkTag);
 				    })(linkTag)
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 779);
